module.exports = __webpack_public_path__ + "static/media/search.2d739656.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/search.svg
// module id = 100
// module chunks = 0